import React from "react";
import { useIsMobileWidth, useWindowDimensions } from "@src/utils/mediaQuery";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  LabelList,
  Label,
  ResponsiveContainer,
  ReferenceLine,
  ReferenceArea,
} from "recharts";

const BehaviourScatterGraph = (props) => {
  const {
    data,
    additionalThresholdsRelative,
    additionalThresholdsActualValues,
    showRefArea,
    domain,
    refLineColour,
    refAreaColour,
    axisLabel,
    hideYAxisOnDesktop = false,
    hideYLabelOnMobile = false,
    hideXLineOnMobile = false,
    hideYLineOnMobile = false,
    isExample = false,
    dotColour,
  } = props;

  const mobileLayout = useIsMobileWidth();
  const { width } = useWindowDimensions();
  const margins = {
    top: 50,
    right: mobileLayout ? 90 : 5,
    bottom: 50,
    left: 30,
  };
  const additionalThresholds = additionalThresholdsRelative
    ? additionalThresholdsRelative
    : additionalThresholdsActualValues;

  return (
    <div id={"signol-chart-container"}>
      {mobileLayout ? (
        <ResponsiveContainer height={width * 1.4} width={"100%"}>
          <ScatterChart margin={margins}>
            <YAxis
              type="number"
              dataKey="x"
              domain={domain}
              axisLine={!hideYLineOnMobile}
              tickLine={false}
              tick={{ fill: "none" }}
              ticks={0}
            >
              {!hideYLabelOnMobile && (
                <Label
                  value={axisLabel}
                  angle="-90"
                  position="insidemiddle"
                  fill="black"
                />
              )}
            </YAxis>
            <XAxis
              type="number"
              dataKey="y"
              domain={(0, 10)}
              axisLine={!hideXLineOnMobile}
              tickLine={false}
              tick={{ fill: "none" }}
              ticks={0}
            />
            <ZAxis range={[3500, 3500]} />
            {additionalThresholds &&
              additionalThresholds.map((listThreshold, index) => (
                <ReferenceLine
                  key={`ref-line-${index}`}
                  label={{
                    position: "right",
                    value: additionalThresholdsActualValues[index],
                    width: 90,
                    fill: refLineColour,
                  }}
                  y={listThreshold}
                  stroke={refLineColour}
                  strokeDasharray="6 6"
                  strokeWidth="3"
                />
              ))}
            {showRefArea && additionalThresholds.length === 2 && (
              <ReferenceArea
                y1={additionalThresholds[0]}
                y2={additionalThresholds[1]}
                fill={refAreaColour}
              />
            )}
            <Scatter name="trim" data={data} fill={dotColour}>
              {!isExample && <LabelList dataKey="label" fill={"white"} />}
            </Scatter>
          </ScatterChart>
        </ResponsiveContainer>
      ) : (
        <ResponsiveContainer width="100%" height={150 * data.length + 100}>
          <ScatterChart margin={margins}>
            <XAxis
              type="number"
              dataKey="x"
              domain={domain}
              tickLine={false}
              tick={{ fill: "none" }}
              ticks={0}
            >
              <Label value={axisLabel} fill="black" position="bottom" />
            </XAxis>
            <YAxis
              type="number"
              dataKey="y"
              domain={(0, 10)}
              axisLine={!hideYAxisOnDesktop}
              tickLine={false}
              tick={{ fill: "none" }}
              ticks={0}
            />
            <ZAxis range={[3500, 3500]} />
            {additionalThresholds &&
              additionalThresholds.map((listThreshold, index) => (
                <ReferenceLine
                  key={`ref-line-${index}`}
                  label={{
                    position: "top",
                    value: additionalThresholdsActualValues[index],
                    width: 90,
                    fill: refLineColour,
                  }}
                  x={listThreshold}
                  stroke={refLineColour}
                  strokeDasharray="6 6"
                  strokeWidth="3"
                />
              ))}
            {showRefArea && additionalThresholds.length === 2 && (
              <ReferenceArea
                x1={additionalThresholds[0]}
                x2={additionalThresholds[1]}
                fill={refAreaColour}
              />
            )}
            {/* note for ReferenceArea using the y1 and y2 values can result in the area not rendering this will happen with a warning or error. */}
            <Scatter name="trim" data={data} fill={dotColour}>
              {!isExample && <LabelList dataKey="label" fill={"white"} />}
            </Scatter>
          </ScatterChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default BehaviourScatterGraph;
